import { useEffect, useState, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { ProductCard } from "@/components/ProductCard";

export const FeaturedCarousel = ({ products = [] }) => {
    const [emblaRef, embla] = useEmblaCarousel({ align: "start", loop: false, dragFree: true });
    const [canPrev, setCanPrev] = useState(false);
    const [canNext, setCanNext] = useState(true);

    const onSelect = useCallback(() => {
        if (!embla) return;
        setCanPrev(embla.canScrollPrev());
        setCanNext(embla.canScrollNext());
    }, [embla]);

    useEffect(() => {
        if (!embla) return;
        onSelect();
        embla.on("select", onSelect);
        embla.on("reInit", onSelect);
    }, [embla, onSelect]);

    return (
        <div className="relative">
            <div className="overflow-hidden" ref={emblaRef} data-testid="featured-carousel">
                <div className="flex gap-4 md:gap-5">
                    {products.map((p) => (
                        <div key={p.id} className="shrink-0 w-[72%] sm:w-[45%] md:w-[31%] lg:w-[23.5%]">
                            <ProductCard product={p} />
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex gap-2 mt-8">
                <button
                    data-testid="carousel-prev"
                    onClick={() => embla && embla.scrollPrev()}
                    disabled={!canPrev}
                    className="h-12 w-12 rounded-full flex items-center justify-center border border-verde text-verde disabled:opacity-25 hover:bg-verde hover:text-white transition-colors"
                    aria-label="Anterior"
                >
                    <ArrowLeft size={20} />
                </button>
                <button
                    data-testid="carousel-next"
                    onClick={() => embla && embla.scrollNext()}
                    disabled={!canNext}
                    className="h-12 w-12 rounded-full flex items-center justify-center border border-verde text-verde disabled:opacity-25 hover:bg-verde hover:text-white transition-colors"
                    aria-label="Siguiente"
                >
                    <ArrowRight size={20} />
                </button>
            </div>
        </div>
    );
};
